import { createRouter, createWebHistory } from 'vue-router';
import { useSuperAdminStore } from '../stores/superAdmin';

const routes = [
    { path: '/', redirect: '/tenants' },
    { path: '/login', name: 'login', component: () => import('../pages/Login.vue'), meta: { public: true } },
    { path: '/tenants', name: 'tenants', component: () => import('../pages/Tenants.vue') },
    { path: '/tenants/:id', name: 'tenant-detail', component: () => import('../pages/TenantDetail.vue') },
    { path: '/plans', name: 'plans', component: () => import('../pages/Plans.vue') },
    { path: '/catalog', name: 'catalog', component: () => import('../pages/Catalog.vue') },
    { path: '/base-catalog', name: 'base-catalog', component: () => import('../pages/BaseCatalog.vue') },
];

const router = createRouter({
    // A SPA é servida na RAIZ do domínio painel.* (a shell vem do Laravel),
    // então o history base é '/', não '/super-admin/'.
    history: createWebHistory('/'),
    routes,
});

router.beforeEach(async (to) => {
    const store = useSuperAdminStore();
    if (!store.booted) {
        await store.bootstrap();
    }
    if (!to.meta.public && !store.isAuthenticated) {
        return { name: 'login', query: { redirect: to.fullPath } };
    }
    if (to.name === 'login' && store.isAuthenticated) {
        return { name: 'tenants' };
    }
    return true;
});

export default router;
